export const initMobileMenuToggle = header => {
    if (!header) return;

    // Open menu toggle click action.
    header.querySelector('#open-menu')?.addEventListener('click', () => {
        document.documentElement.classList.add('no-scroll');
        window.scrollTo({ top: 0 });
        header.classList.add('open');
    });

    // Close menu toggle click action.
    header.querySelector('#close-menu')?.addEventListener('click', () => {
        document.documentElement.classList.remove('no-scroll');
        header.classList.remove('open');

        const menus = header.querySelector('.mobile-navigation .menus');
        if (!menus) return;

        // Reset "menus" transform value.
        menus.style.setProperty('transform', '');

        // Hide submenus.
        menus.querySelectorAll('.mobile-menu-container:not(:first-child) .mobile-menu').forEach(submenu => {
            submenu.classList.add('hidden');
        });
    });
};
